<template>
  <span style="color: #02A7F0;">{{ newValue }}</span>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      newValue: "",
      interval: null
    }
  },
  mounted() {
    this.interval = setInterval(() => {
      var now = new Date().getTime();
      var timeRemaining = new Date(this.value) - now;

      var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      var hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      function fillZero(val) {
        return val > 10 ? val : "0" + val
      }

      this.newValue = days + "天" + fillZero(hours) + "小时" + fillZero(minutes) + "分钟";

      if (timeRemaining <= 0) {
        this.newValue = "";
        // 倒计时结束，可以执行其他操作
        clearInterval(this.interval);
      }
    }, 1000);
  },
}
</script>